import Organisations from './Organisations';

export default Organisations;
